import React from 'react';
import propTypes from 'prop-types';
import Tippy from '@tippy.js/react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function UiTooltip({ content, icon, ...props }) {
  return (
    <Tippy
      content={content}
      arrow
      distance={5}
      {...props}
      theme="terra"
      placement="top"
    >
      <span className="icon is-small tippy-icon">
        <FontAwesomeIcon icon={icon} size="xs" />
      </span>
    </Tippy>
  );
}

UiTooltip.defaultProps = {
  icon: ['fal', 'info-circle'],
};

UiTooltip.propTypes = {
  content: propTypes.string.isRequired,
  icon: propTypes.oneOfType([
    propTypes.string,
    propTypes.arrayOf(propTypes.string),
  ]),
  ..._.filter(Tippy.propTypes, (_v, k) => k !== 'children'),
};
